<template>
  <div>
    <!-- 业务商品信息录入表单 -->
    <el-dialog :title="$t('message.businessCommodityInformationEntry')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1380px" center>
      <div class="content">

        <div class="table">
          <ol>
            <!-- 订单号 -->
            <li>{{ $t('message.orderNumber') }}</li>
            <!-- NO -->
            <li class="flex05">NO</li>
            <!--图片  -->
            <li>{{ $t('message.pic') }}</li>
            <!-- 业务编辑属性 -->
            <li class="flex15">{{ $t('message.businessEditAttributes') }}</li>
            <!-- 商品数量 -->
            <li>{{ $t('message.numberOfProducts') }}</li>
            <!-- 业务商品备注 -->
            <li>{{ $t('message.salesmanCommodityRemarks') }}</li>
            <!-- 普通检品操作时长(单个) -->
            <li class="flex15">{{ $t('message.normalInspectionOperationDuration') }}</li>
            <!-- 附加服务（单个服务操作时长） -->
            <li class="flex2">{{ $t('message.additionalServiceOperationDuration') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 订单号 -->
            <li>{{ item.order_sn }}</li>
            <!-- NO -->
            <li class="flex05">{{ item.sorting }}</li>
            <!--图片  -->
            <li>
              <img :src="item.pic" alt="" style="width: 100px; height: 100px;">
            </li>
            <!-- 业务编辑属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 商品数量 -->
            <li>
              <div class="template">
                <div class="template attribute">
                  <!-- 可入库 -->
                  <p class="row">{{ $t("message.canBePutIntoStorage") }}:{{ item.possible_num_total }}</p>
                  <!-- 已到货 -->
                  <p>{{ $t("message.itHasArrived") }}:{{ item.storage_num_total }}</p>
                  <!-- 已出货 -->
                  <p>{{ $t("message.shipped") }}:{{ item.delivery_total }}</p>
                </div>
              </div>
            </li>
            <!-- 业务商品备注 -->
            <li>{{ item.y_remark }}</li>
            <!-- 普通检品操作时长(单个) -->
            <li class="flex15">
              <el-input v-model="item.inspect_minute" placeholder="长" size="small" type="number"><template
                  slot="append">分钟</template></el-input>
            </li>
            <!-- 附加服务（单个服务操作时长） -->
            <li class="flex2">
              <div class="optionList">
                <div class="row" v-for="(itemDetail, itemIndex) in item.duration_json" :key="itemIndex">
                  <div class="name">
                    {{ itemDetail.name }}:
                  </div>
                  <div class="val">
                    <el-input v-model="itemDetail.minute" size="mini" type="number"><template
                        slot="append">分钟</template></el-input>
                  </div>
                </div>

              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {

      dialogVisible: false,
      datas: {
        order_sn: '',
        order_detail_ids: [],
      },
      selectedList: [],
      tableData: [],// 配货商品信息录入表单数据
    };
  },
  methods: {
    // 服务单商品信息录入表单
    businessPreview() {
      this.$api.spotCheckApi.businessPreview(this.datas).then(res => {
        res.data.list.forEach(item => {
          this.selectedList.forEach(selectedItem => {
            if (selectedItem.id == item.id) {
              item.detail_y = selectedItem.detail_y
              item.y_remark = selectedItem.y_remark
              item.possible_num_total = selectedItem.possible_num_total
              item.storage_num_total = selectedItem.storage_num_total
              item.delivery_total = selectedItem.delivery_total
            }
          })
        })
        this.tableData = res.data.list
        this.dialogVisible = true
      })
    },
    // 保存
    save() {
      let datas = {
        task_sn: '',
        list: []
      }
      this.tableData.forEach(item => {
        datas.list.push({
          order_detail_id: item.id,
          inspect_minute: item.inspect_minute,
          duration_json: item.duration_json,

        })
      })
      this.$api.spotCheckApi.businessSave(datas).then(res => {
        this.$message({
          message: res.msg,
          type: 'success'
        })
        this.dialogVisible = false
        this.$parent.refresh()
      })
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;



  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 12px 12px;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex2 {
      flex: 2;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }


  }

  .table {
    max-height: 600px;
    overflow: auto;

    .row {
      margin-bottom: 5px;



    }

    .optionList {


      .row {
        display: flex;
      }

      .name {
        width: 160px;
        line-height: 32px;

      }
    }
  }



}
</style>